import { Injectable, EventEmitter } from '@angular/core';
import { WebSocketSubject } from 'rxjs/websocket';
import { fromEvent } from 'rxjs';
import { Scanner } from '../model/scanner';
import { AuthService } from './auth.service';

export interface ScannerMessage {
  InUse: boolean;
  UserInUse: string;
  ImageBase64: string;
  ImageDuplexBase64: string;
}


@Injectable()
export class ScannWebSocketService {

  isClosed: boolean;
  private socket$: WebSocket;
  public imageReceived: EventEmitter<string>;
  public inUseReceived: EventEmitter<string>;
  public errorReceived: EventEmitter<boolean>;
  public closeReceived: EventEmitter<boolean>;
  public openReceived: EventEmitter<boolean>;

  constructor(private authService: AuthService) {
    this.imageReceived = new EventEmitter<string>();
    this.errorReceived = new EventEmitter<boolean>();
    this.closeReceived = new EventEmitter<boolean>();
    this.openReceived = new EventEmitter<boolean>();
    this.inUseReceived = new EventEmitter<string>();
    this.isClosed = true;
  }

  public startConnection(scanner: Scanner) {

    if (this.isClosed) {

      this.socket$ = new WebSocket('ws://' + scanner.Ip);
      const observable$ = fromEvent(this.socket$, 'message');

      this.socket$.onerror = (event) => {
        this.isClosed = true;
        this.errorReceived.emit(true);
      };

      this.socket$.onclose = (event) => {
        this.isClosed = true;
        this.closeReceived.emit(true);
      };

      this.socket$.onopen = (event) => {
        this.isClosed = false;
        this.openReceived.emit(true);
      };

      observable$.subscribe((message: MessageEvent) => {
        const scannerMessage = <ScannerMessage>JSON.parse(message.data);
        if (!scannerMessage.InUse && scannerMessage.ImageBase64) {
          this.imageReceived.emit(scannerMessage.ImageBase64);
          if (  scannerMessage.ImageDuplexBase64 ) {
            this.imageReceived.emit(scannerMessage.ImageDuplexBase64);
          }
        } else {
          this.inUseReceived.emit(scannerMessage.UserInUse);
        }
      });
    }
  }

  public closeConnection(): void {
    if (!this.isClosed) {
      this.socket$.close();
    }
  }

  public sendScann(): void {
    if (!this.isClosed) {
      // le paso el usuario por si despues quieren saber quien esta ocupando el escaner
      this.socket$.send(this.authService.getUserName());
    }
  }
}
